<!-- Default hero option with no carousel -->
<div>
  <ng-container *ngTemplateOutlet="heroContent; context: {item: block}"></ng-container>
</div>


<!-- Hero content used in both default/carousel options -->
<ng-template #heroContent let-item="item">
  <div class="home-banner">
    <div class="home-banner__container container">
      <div class="home-banner__container over">
        <div class="home-banner__content">
          <div class="home-banner__content-text"></div>
          <div [style.background-image]="getBackground(item.data.image)"
               [style.background-position]="item.data.heroImagePosition"
               class="home-banner__content-image"
               role="none">
          </div>
        </div>
      </div>

      <div class="home-banner__content">
        <div class="home-banner__content-text">
          <h1 *ngIf="item.data.heading" [innerHTML]="item.data.heading" class="home-banner__heading-primary"></h1>
          <h2 *ngIf="item.data.subheading" [innerHTML]="item.data.subheading"
              class="home-banner__heading-secondary"></h2>
          <div *ngIf="item.data.content" [innerHTML]="item.data.content" class="home-banner__paragraph"></div>
          <a *ngIf="item.data.link && !item.data.targetAttr" [attr.aria-label]="item.data.linkAriaLabel"
             [core-analytics]="{action: block.data.linkText, block}"
             [innerText]="item.data.linkText ?? 'Learn more'" [routerLink]="item.data.link"
             [target]="item.data.targetAttr ? '_blank' : '_self'"
             class="btn btn-primary"></a>

          <a *ngIf="item.data.link && item.data.targetAttr" [attr.aria-label]="item.data.linkAriaLabel"
             [core-analytics]="{action: block.data.linkText, block}"
             [href]="item.data.link" [innerText]="item.data.linkText ?? 'Learn more'"
             [target]="item.data.targetAttr ? '_blank' : '_self'"
             class="btn btn-primary"></a>

        </div>
      </div>
    </div>
  </div>
</ng-template>

